<ng-container *ngIf="entityType == 'EKAMPUS'">
  <app-forgetEkampus></app-forgetEkampus>
</ng-container>
<ng-container *ngIf="entityType == 'IP'">
  <app-forgetIP></app-forgetIP>
</ng-container>
